<div *ngIf="data">
	<h1 mat-dialog-title>{{ 'Edit' | translate}} <span *ngIf="!showMobile">Desktop</span><span *ngIf="showMobile">Mobile</span> {{data.title}}</h1>
	<div mat-dialog-content style="overflow: visible;">
		<app-layout-row-data *ngIf="data" [templateSettings]="templateSettings" [data]="data" [templateDisabled]="templateDisabled" (closeModalReturn)="closeModal($event)" (showMobileReturn)="showMobile = $event"></app-layout-row-data>
	</div>
</div>
